import { SHTableHead, SHTableRow } from "@components/design-systems";
import { HeaderGroup } from "@tanstack/react-table";
import React from "react";
import { useTheme } from "@mui/material";
import { hexToRGBA } from "@utils";
import { MSTableHeadCell } from "@pages/managed-accounts/model-screener/components/model-screener-table/table/table-head-cell";
import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";

type ModelScreenerTableHeaderProps = {
  headerGroups?: HeaderGroup<ModelScreenerRow>[];
};

export const ModelScreenerTableHeader = ({
  headerGroups,
}: ModelScreenerTableHeaderProps) => {
  const { palette } = useTheme();

  return (
    <SHTableHead
      sx={{
        display: "grid",
        position: "sticky",
        top: 0,
        zIndex: 1,
      }}
    >
      {headerGroups?.map((group) => {
        const isMainHeader = group.depth === 0;

        return (
          <SHTableRow
            key={group.id}
            sx={{
              width: "100%",
              display: "flex",
              "&:first-of-type": {
                backgroundColor: isMainHeader
                  ? hexToRGBA(palette.secondary[100], 0.2)
                  : undefined,
              },
              borderBottomWidth: isMainHeader ? "0px !important" : undefined,
              borderTop: `1px solid ${palette.grey["300"]} !important`
            }}
          >
            {group.headers.map((header) => {
              return (
                <MSTableHeadCell
                  key={header.id}
                  header={header}
                  isMainHeader={isMainHeader}
                />
              );
            })}
          </SHTableRow>
        );
      })}
    </SHTableHead>
  );
};
